import { render, staticRenderFns } from "./AiModelTraining.vue?vue&type=template&id=5bc4d864&scoped=true"
import script from "./AiModelTraining.vue?vue&type=script&lang=js"
export * from "./AiModelTraining.vue?vue&type=script&lang=js"
import style0 from "./AiModelTraining.vue?vue&type=style&index=0&id=5bc4d864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc4d864",
  null
  
)

export default component.exports